























































/* eslint-disable */
export default {
  name: "TimeSelect",
  props: {
    color: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Time"
    },
    minuteGroups: {
      type: Array,
      default: () => [0, 15, 30, 45]
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      expandedMinutes: null,
      minMenu: false
    };
  },
  computed: {
    hour24(): any {
      if (!((this as any).$props as any).value) return 12;
      return Number(((this as any).$props as any).value.split(":")[0]);
    },
    hour: {
      get() {
        return (this as any).hour24 % 12 === 0 ? 12 : (this as any).hour24 % 12;
      },
      set(value:any) {
        if (value) {
          const hr = `${(value === 12 ? 0 : (value as any)) +
            ((this as any).isAm ? 0 : 12)}`.padStart(2, "0");
          (this as any).$emit("input", `${hr}:${(this as any).minute}`);
        }
      }
    },
    expandedStart() {
      return (this as any).expandedMinutes
        ? parseInt((this as any).expandedMinutes.split("-")[1])
        : -1;
    },
    expandedEnd() {
      return (this as any).expandedMinutes
        ? parseInt((this as any).expandedMinutes.split("-")[2])
        : -1;
    },
    minuteList():any {
      return Array.from(Array(60).keys())
        .map(i => {
          if (
            ((this as any).minuteGroups as any).includes(i) ||
            ((i as any) >= this.expandedStart && (i as any) <= this.expandedEnd)
          ) {
            return `${i}`.padStart(2, "0");
          } else if (((this as any).minuteGroups as any).includes(i - 1)) {
            const end = ((this as any).minuteGroups as any).find((a:any) => (a as any) > i) || 59;
            return `ellipsis-${i}-${end}`;
          } else {
            return false;
          }
        })
        .filter(i => !!i);
    },
    minute: {
      get() {
        if (!(this as any).$props.value) return "00";
        return (this as any).$props.value.split(":")[1].replace(/\D+/g, "");
      },
      set(value: any) {
        if (value) {
          (this as any).$emit(
            "input",
            `${("" + (this as any).hour24).padStart(2, "0")}:${value}`
          );
        }
      }
    },
    isAm: {
      get() {
        return (this as any).hour24 < 12;
      },
      set(toAm: any) {
        if (toAm === (this as any).isAm) return; // avoid if not changing
        const hr = `${(this as any).hour24 + (toAm ? -12 : 12)}`.padStart(2, "0");
        (this as any).$emit("input", `${hr}:${(this as any).minute}`);
      }
    }
  },
  methods: {
    onMinuteClick(min: any) {
      const isEllipsis = min.includes("-");
      (this as any).expandedMinutes = isEllipsis ? min : null;
      if (!isEllipsis) {
        (this as any).minMenu = false;
        (this as any).minute = min;
      }
    },
    getMinuteClass(min: any): any {
      return (this as any).minuteGroups.includes(parseInt(min))
        ? "font-weight-bold"
        : "";
    }
  }
};
